import {
    FormControl,
    FormHelperText,
    FormLabel,
    InputLabel,
    MenuItem,
    Select,
    styled,
} from '@mui/material';
import { Controller } from 'react-hook-form';

const CustomBorderSelect = styled(Select)`
    &.Mui-focused {
        & fieldset {
            border-color: #3A3A3A !important;
        }
    }
`;
  
const AuthSelect = (props) => {
    const {
      hookFormControl,
      varName,
      disabled = false,
      options,
      errorMessage = null,
      withSelect = true,
      size = "small",
      placeholder = ''
    } = props;
  
    return (
        <FormControl error={errorMessage !== null} size={size} fullWidth>
            <Controller
                name={varName}
                control={hookFormControl}
                render={({ field }) => (
                    <CustomBorderSelect
                        id={varName}
                        disabled={disabled}
                        size={size}
                        {...field}
                        renderValue={(selected) => {
                            if (!selected || selected.length === 0)
                                return <span className='text-[#b9b9b9]'>{placeholder}</span>;
                            return options?.find((item) => item.value === selected).label;
                        }}
                        error={false}
                        displayEmpty
                        inputProps={{ className: "font-['Poppins-Regular'] text-[15px] text-center" }}
                        value={field?.value ? field.value : ''}
                        className="rounded-full"
                        sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px' }}
                    >
                        {withSelect && (
                            <MenuItem value={''} key={'def-numb'} sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px', }} disabled={options.length === 0} >
                                <em>Select</em>
                            </MenuItem>
                        )}
                    
                        {options.map((a) => (
                            <MenuItem sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px', }} title={a?.info ?? a.label} disabled={a.disabled ? true : false} value={a.value} key={a.label}>
                                {a.label}
                            </MenuItem>
                        ))}
                    </CustomBorderSelect>
                )}
            />
            {errorMessage && (
                <FormHelperText className="ml-0 font-['Poppins-Regular'] text-[11px]" id="component-error-text">
                    {errorMessage}
                </FormHelperText>
            )}
        </FormControl>
    );
};
  
export default AuthSelect;
  